import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-nao-autorizado",
  template: `
    <div style="display:flex;justify-content:center;margin-top:60px">
      <p-card header="Acesso não autorizado" styleClass="text-center">
        <p>Você não possui permissão para acessar este recurso.</p>
        <button
          pButton
          type="button"
          label="Voltar"
          (click)="voltar()"
        ></button>
      </p-card>
    </div>
  `,
})
export class NaoAutorizadoComponent {
  constructor(private router: Router) {}

  voltar() {
    this.router.navigate(["/caixa"]);
  }
}
